((app, ng) => {

    app.controller("editAccountRelationshipsController", editAccountRelationshipsController);

    function editAccountRelationshipsController($mdDialog, _householdRelationshipTypes, accountRelationshipApi, householdRelationshipApi, personApi, clientApi, businessApi) {
        const $ctrl = this;

        const close = () => {
            $mdDialog.hide();
        }

        const deleteRelationship = (relationshipId) => {
            return accountRelationshipApi.deleteAccountRelationship(relationshipId);
        }

        const createRelationship = (relationship) => {
            return accountRelationshipApi.createAccountRelationship(relationship).then(response => {
                relationship.Id = response.Id;
            });
        }

        const createEntity = (entity) => {
            if (entity.Type === "Individual") {
                return personApi.add(entity.Person);
            }

            return businessApi.create(entity.Business);
        }

        const getBeneficiaryList = (beneficiaryType) => {
            const beneficiaryLists = {
                Beneficiary: function () {
                    if (!$ctrl.relationships.Beneficiaries) $ctrl.relationships.Beneficiaries = [];
                    return $ctrl.relationships.Beneficiaries;
                },
                ContingentBeneficiary: function () {
                    if (!$ctrl.relationships.ContingentBeneficiaries) $ctrl.relationships.ContingentBeneficiaries = [];
                    return $ctrl.relationships.ContingentBeneficiaries;
                },
            }

            return beneficiaryLists[beneficiaryType]();
        }

        const getTotalBeneficiaryPercentage = (beneficiaryType) => {
            const beneficiaryPercentageTotals = {
                Beneficiary: $ctrl.totalBeneficiaryPercentage,
                ContingentBeneficiary: $ctrl.totalContingentBeneficiaryPercentage,
            }

            return beneficiaryPercentageTotals[beneficiaryType];
        }

        const updateTotalBeneficiaryPercentage = (beneficiaryType) => {
            const updateTotalPercentage = {
                Beneficiary: function () {
                    if ($ctrl.relationships.Beneficiaries) {
                        $ctrl.totalBeneficiaryPercentage = $ctrl.relationships.Beneficiaries.reduce(
                            (sum, beneficiary) => {
                                return sum + beneficiary.BeneficiaryPercentage;
                            }, 0);
                    }
                },
                ContingentBeneficiary: function () {
                    if ($ctrl.relationships.ContingentBeneficiaries) {
                        $ctrl.totalContingentBeneficiaryPercentage = $ctrl.relationships.ContingentBeneficiaries.reduce(
                            (sum, beneficiary) => {
                                return sum + beneficiary.BeneficiaryPercentage;
                            }, 0);
                    }
                },
            }

            updateTotalPercentage[beneficiaryType]();
        }

        const updateRelationship = (newClientId, relationshipType) => {
            const prevRelationship = $ctrl.relationships[relationshipType];

            if (!!prevRelationship)
                deleteRelationship(prevRelationship.Id);

            if (!!newClientId) {
                const newClient = $ctrl.clientHousehold.find(member => member.Id === newClientId);

                const relationship = {
                    ...$ctrl.defaultRelationship,
                    Person: newClient.Person,
                    AccountRelationshipType: relationshipType,
                }

                if (relationshipType !== "Owner") relationship.HouseholdRelationshipType = newClient.Type;

                $ctrl.relationships[relationshipType] = relationship;

                createRelationship(relationship);
            }
        }

        const addBeneficiary = (personId, beneficiaryType) => {
            const newClient = $ctrl.clientHousehold.find(member => member.Id === personId);

            const relationship = {
                ...$ctrl.defaultRelationship,
                AccountRelationshipType: beneficiaryType,
                BeneficiaryPercentage: 0,
                Person: newClient.Person,
                HouseholdRelationshipType: newClient.Type,
            };

            getBeneficiaryList(beneficiaryType).push(relationship);

            createRelationship(relationship);
        }

        const addNewEntityBeneficiary = (entity, beneficiaryType) => {
            const relationship = {
                ...$ctrl.defaultRelationship,
                AccountRelationshipType: beneficiaryType,
                BeneficiaryPercentage: 0,
                Person: entity.Person,
                HouseholdRelationshipType: entity.HouseholdRelationshipType,
                Business: entity.Business,
            }

            getBeneficiaryList(beneficiaryType).push(relationship);

            createEntity(entity).then(response => {
                if (!!entity.Person) {
                    relationship.Person.Id = response.Id;
                } else {
                    relationship.Business.Id = response.Id;
                }

                createRelationship(relationship);
            });
        }

        const updateBeneficiaryPercentage = (beneficiary, beneficiaryType) => {
            if (getTotalBeneficiaryPercentage(beneficiaryType) <= 100) {
                accountRelationshipApi.updateBeneficiaryPercentage(beneficiary.Id, beneficiary);
            }
        }

        const deleteBeneficiary = (beneficiaryId, beneficiaryType) => {
            const beneficiaryList = getBeneficiaryList(beneficiaryType);

            const beneficiaryIndex = beneficiaryList.findIndex(beneficiary => beneficiary.Id === beneficiaryId);

            beneficiaryList.splice(beneficiaryIndex, 1);

            updateTotalBeneficiaryPercentage(beneficiaryType);

            deleteRelationship(beneficiaryId);
        }

        const searchClients = (term) => {
            return clientApi.searchClients(term).then(clients => clients);
        }

        ng.extend($ctrl,
            {
                close,
                searchClients,
                updateRelationship,
                addBeneficiary,
                addNewEntityBeneficiary,
                updateBeneficiaryPercentage,
                deleteBeneficiary,
                updateTotalBeneficiaryPercentage,
            });

        $ctrl.$onInit = () => {
            $ctrl.householdRelationshipTypes = _householdRelationshipTypes;
            $ctrl.clientHousehold = [];

            $ctrl.relationshipIds = {
                ...Object.keys($ctrl.relationships).map(relationship => {
                    return {
                        [relationship]: $ctrl.relationships[relationship].PersonId
                    }
                })
            }

            $ctrl.defaultRelationship = {
                InsuranceAccountId: $ctrl.account.InsuranceAccountId,
                InvestmentAccountId: $ctrl.account.InvestmentAccountId,
            }

            $ctrl.updateTotalBeneficiaryPercentage("Beneficiary");
            $ctrl.updateTotalBeneficiaryPercentage("ContingentBeneficiary");

            householdRelationshipApi.getHouseholdRelationships($ctrl.client.Id).then(household => {
                $ctrl.clientHousehold = household.map(member => {
                    return {
                        Id: member.TargetClient.Id,
                        Person: member.TargetClient.Person,
                        Type: member.Type.ShortName,
                    }
                });
            });
        };
    }
})(window.app, window.angular);